import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { GenericClassService } from '../../@core/backend/common/services/genericClass.service';
import { NbToastrService, NbDialogService, NbDialogRef } from '@nebular/theme';
import { DxDataGridComponent, DxTreeListComponent } from 'devextreme-angular';
import { ModalFilterComponent } from '../modal-filter/modal-filter.component';
import { truncate } from 'fs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-modal-list-class',
  templateUrl: './modal-list-class.component.html',
  styleUrls: ['./modal-list-class.component.scss'],
})
export class ModalListClassComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  @ViewChild(DxTreeListComponent, { static: false })
  treeGrid: DxTreeListComponent;
  store: any;

  @Input('context.nameClass') nameClass: string;
  @Input('context.domainName') domainName: string;
  @Input('context.otherClass') otherClass: string;
  @Input('context.title') title: string;
  @Input('context.baseFilter') baseFilter: any = null;
  @Input('context.selectFilter') selectFilter: any = null;
  @Input('context.treeRoot') treeRoot: number = 0;
  expandedRowKeys: any[] = [];
  settings: any;
  firstColumnName: any;

  @Output() onSelected = new EventEmitter<any>();
  filter: any[];
  styleNormal: any;
  okSeleziona: boolean;
  mode: string;
  selctable: any = null;
  data: any;
  listClassAlias: any[];
  listClassColor = [
    '993300',
    '30373D',
    '003300',
    '800000',
    'FF6600',
    '808000',
    '008000',
    '0000FF',
    '666699',
    '808080',
    'FF0000',
    'FF9900',
    '99CC00',
    '339966',
    '33CCCC',
    '3366FF',
    '800080',
    '969696',
    'FF00FF',
    'FFCC00',
    'FFFF00',
    '00FF00',
    '00FFFF',
    '00CCFF',
    '993366',
    'C0C0C0',
    'FF99CC',
    'FFCC99',
    'FFFF99',
    'CCFFCC',
    'CCFFFF',
    '99CCFF',
    'CC99FF',
    'FFFFFF',
  ];
  constructor(
    private classService: GenericClassService,
    private toasterService: NbToastrService,
    protected ref: NbDialogRef<ModalFilterComponent>,
    private dialogService: NbDialogService,
    private translate: TranslateService,
  ) {
    this.styleNormal = {
      width: window.innerWidth * 0.9 + 'px',
      height: window.innerHeight * 0.9 + 'px',
    };
  }

  ngOnInit() {
    this.okSeleziona = false;
    this.selctable = null;
    this.settings = { columns: [] };
    if (!this.nameClass) {
      console.log(this.domainName, this.otherClass);
      this.classService
        .getInverseClass(this.otherClass, this.domainName)
        .subscribe((res) => {
          this.nameClass = res.data;
          this.loadData();
        });
    } else {
      this.loadData();
    }
  }
  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    // Modifies an existing item
    toolbarItems.forEach(function (item) {
      if (item.name === 'searchPanel') {
        item.location = 'before';
      }
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'refresh',

        onClick: this.refreshDataGrid.bind(this),
      },
    });
  }

  // Preserve original property order
  originalOrder = (): number => {
    return 0;
  }

  refreshDataGrid() {
    const instance = this.dataGrid
      ? this.dataGrid.instance
      : this.treeGrid.instance;
    instance.refresh();
  }
  clearFilterDataGrid() {
    this.filter = [];
  }
  addFilterDataGrid() {
    this.apriModalFilter();
  }
  // FILTRI
  apriModalFilter() {
    // crea fields
    const fields: Array<any> = [];

    // tslint:disable-next-line: forin
    for (const key in this.settings.columns) {
      const element = this.settings.columns[key];
      fields.push({
        caption: element.title,
        dataField: key,
        dataType: element.type,
      });
    }

    this.dialogService
      .open(ModalFilterComponent, {

        context: {
          fields: fields,
          className: this.nameClass,
          filter: this.filter,
        },
      })
      .onClose.subscribe((res) => {
        if (res) {
          // this.dataGrid.instance.filter(res);
          this.filter = res;
        }
      });
  }
  loadedSelectable(res) {
    this.selctable = res.data.map((x) => x.Id);
  }
  loaded(res) {
    this.data = res.data;
    const root = this.data.find(x => !x.ParentId);
    this.expandedRowKeys = root ? [root.Id] : [];
  }
  loadData() {
    this.settings.columns = null;
    // CARICA COLONNE
    this.classService.getClass(this.nameClass).subscribe((res) => {
      if (res.status == 'success') {
        // CARICA DATI
        this.store = this.classService.getDataSourceDevExp(
          this.nameClass,
          this.baseFilter, false, this.treeRoot,
        );
        if (res.data.classData.isTree == 'true') {
          this.store.on('loaded', this.loaded.bind(this));
          this.store.load();
        }

        if (this.selectFilter && this.selectFilter.length > 0) {
          const selectableFilter = [].concat(
            [this.baseFilter && this.baseFilter.length > 0 ? this.baseFilter : ['Status', '=', 'A']],
            'and',
            [this.selectFilter],
          );
          const storeSelectFilter = this.classService.getDataSourceDevExp(
            this.nameClass,
            selectableFilter,
          );
          storeSelectFilter.on('loaded', this.loadedSelectable.bind(this));
          storeSelectFilter.load();
        }

        this.mode = res.data.classData.isTree == 'true' ? 'tree' : 'grid';
        if (this.mode == 'tree') {
          this.listClassAlias = [];
          let colorCount = 1;
          res.data.classData.listClass.forEach((element) => {
            const color = this.listClassColor[colorCount];

            console.log(color);
            this.listClassAlias[element.className.replaceAll('"', '')] = {
              alias: element.labelName,
              cssClass: color,
            };
            colorCount++;
          });
          if (!Object.keys(res.data.list).includes('Tipo')) {
            res.data.list['Tipo'] = {
              Metadata: null,
              index: 3,
              lookup: null,
              reference: null,
              referenceClassName: '',
              required: false,
              sortIndex: 0,
              sortOrder: null,
              title: 'Tipo',
              type: 'string',
              template: 'typeClassAlias',
            };
          }
        }
        // Normalizza lookup e reference
        const newKeyValues = Object.keys(res.data.list).map((key) => {
          const newKey =
            res.data.list[key].lookup || res.data.list[key].reference
              ? '_' + key + '_Description'
              : key;
          const newValue = res.data.list[key];
          newValue.title =
            this.translate.instant(this.nameClass + '.' + key) ||
            newValue.title;
          const newObject = { [newKey]: newValue };
          return newObject;
        });

        res.data.list = Object.assign({}, ...newKeyValues);

        // Imposta colonne tabella
        this.settings.columns = res.data.list;
        this.settings['summary'] = res.data.summary;

        const kyz = Object.keys(this.settings.columns);
        this.firstColumnName = this.settings.columns[kyz[0]]['title'];
      } else {
        this.toasterService.danger('', `ERRORE: ${res.status} - ${res.data}`);
      }
    });
  }
  clean(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }


  
   getBreadcrumb(element) {
    const node = element;
    const tipoTree = node.Tipo && node._Tipo_Description ? "Tipo" : "";
    node.breadcrumbLevel = {};
    node.breadcrumb = {};
     this.classService.getBreadcrumb(this.nameClass,node.Id,tipoTree).subscribe( (res)=>{
       res.data.forEach( element => {
        const tipo = tipoTree ? element.node.Tipo_Description : element.node.IdClass;
        const newNode = {
          level: 0,
          tipo: tipo,
          Id: element.node.Id,
          ParentId: 0,
          Code: element.node.Code,
          Description: element.node.Description,
        };
        if(!node.breadcrumb[tipo]) node.breadcrumb[tipo] = newNode;
        node.breadcrumbLevel[element.level] = newNode;

      });
      console.log(res.data)
    })
    
  }

  seleziona() {
    const instance = this.dataGrid
      ? this.dataGrid.instance
      : this.treeGrid.instance;

    if (this.treeGrid) {
      // SE E' UN ALBERO RECUPERO IL PERCORSI
      instance.getSelectedRowsData().forEach((element) => {
        this.getBreadcrumb(element)
        console.log(element)
         
      });
    }
    this.onSelected.emit(instance.getSelectedRowsData());
    this.ref.close(instance.getSelectedRowsData());
  }
  close() {
    this.ref.close();
  }

  onSelectionChanged(e) {
    if (this.selctable !== null) {
      this.okSeleziona = false;

      const toDeSelect = e.selectedRowKeys.filter(
        (x) => !this.selctable.includes(x),
      );
      e.component.deselectRows(toDeSelect);
      this.okSeleziona = e.selectedRowKeys.length - toDeSelect.length > 0;
    } else {
      this.okSeleziona = true;
    }
  }
  lookup_calculateCellValue(row) {
    const column = this as any;
    const dataField = column.dataField;

    const fieldName = dataField.replace('_Description', '').replace('_', '');
    let label = '';
    if (row[dataField]) {
      if (row['_' + fieldName + '_IconFont']) {
        if (row['_' + fieldName + '_IconColor']) {
          label +=
            `<span class="` +
            row['_' + fieldName + '_IconFont'] +
            `" style="color:` +
            row['_' + fieldName + '_IconColor'] +
            `"></span>&nbsp;&nbsp;`;
        } else {
          label +=
            `<span class="` +
            row['_' + fieldName + '_IconFont'] +
            `" ></span>&nbsp;&nbsp;`;
        }
      }
      if (row['_' + fieldName + '_TextColor']) {
        label +=
          `<span style="color:` +
          row['_' + fieldName + '_TextColor'] +
          `" >${row[dataField]}</span>`;
      } else {
        label += `<span>${row[dataField]}</span>`;
      }
      column.encodeHtml = false;
    }
    return label;
  }
  calculateCellValueDefault(row) {
    const column = this as any;
    return column.defaultCalculateCellValue(row);
  }
}
